import produce from 'immer';
import { StepProductsAction } from '../../../actions/workflows/steps/Products';
import * as Constants from '../../../constants/action-constants';
import initialState from '../../../InitialState';
import { ProductStep } from '../../../types/workflows/steps/Product';

const productsStep = (
  state: ProductStep = initialState.environmentWorkflow.steps.products,
  action: StepProductsAction
): ProductStep => {
  return produce<ProductStep, ProductStep>(state, draft => {
    switch (action.type) {
      case Constants.INITIALIZE_STEP_PRODUCTS: {
        draft.fetching = true;
        draft.failed = false;
        break;
      }
      case Constants.INITIALIZE_STEP_PRODUCTS_FAILED: {
        draft.fetching = false;
        draft.failed = true;
        break;
      }
      case Constants.INITIALIZE_STEP_PRODUCTS_SUCCESS: {
        const {
          productsMetadata,
          productsDisplayMetadata,
          vCenters,
          existingVidm,
          vropsLogForwardingEntities
        } = action.payload;
        Object.assign(draft, {
          fetching: false,
          vCenters,
          existingVidm,
          productsMetadata,
          productsDisplayMetadata,
          vropsLogForwardingEntities
        });
        break;
      }
      case Constants.ADD_PRODUCT_NODE: {
        const { productId, nodeMetadata, displayMetadata } = action.payload;
        const pIdx = draft.productsMetadata.findIndex(
          p => p.productName === productId
        );
        if (pIdx >= 0) {
          draft.productsMetadata[pIdx].productNodes.splice(0, 0, nodeMetadata);
          draft.productsDisplayMetadata[pIdx].nodes.splice(
            0,
            0,
            displayMetadata
          );
        }
        break;
      }
      case Constants.DELETE_PRODUCT_NODE: {
        const { productId, nodeIndex } = action.payload;
        const pIdx = draft.productsMetadata.findIndex(
          p => p.productName === productId
        );
        if (pIdx >= 0) {
          draft.productsMetadata[pIdx].productNodes.splice(nodeIndex, 1);
          draft.productsDisplayMetadata[pIdx].nodes.splice(nodeIndex, 1);
        }
        break;
      }
      case Constants.ADD_COLLECTOR_GROUP_DISPLAY_METADATA: {
        const { displayMetadata } = action.payload;
        draft.collectorGroupDisplayMetadata =
          draft.collectorGroupDisplayMetadata || [];
        const isMetadataExists = draft.collectorGroupDisplayMetadata.some(
          meta => meta.name === displayMetadata.name
        );
        if (!isMetadataExists) {
          draft.collectorGroupDisplayMetadata.push(displayMetadata);
        }

        break;
      }
      case Constants.DESTROY_STEP_PRODUCTS: {
        draft = initialState.environmentWorkflow.steps.products;
        break;
      }
    }
  });
};

export default productsStep;
